import React, { useState, useReducer, useContext } from 'react';
import Downshift from 'downshift';
import PropTypes from 'prop-types';
import qs from 'qs';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import getResponseJson from '../../services/getresponsejson';
import CoderChip from '../coderchip/coderchip';
import { RouteFetcherContext } from '@mk-redbox/route-fetcher';

const styles = theme => ({
  root: {
    position:'relative'
  },
  primaryContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    border: '1px solid black',
    padding:'.8em'
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& label': {
      marginRight:'8px'
    }
  },
  selectedItemContainer: {
    display: 'inline-block',
    marginLeft: '1em'
  },
  optionsContainer: {
    position: 'absolute',
    marginLeft: '62px',
    width: '11em',
    height: '170px',
    overflowY: 'auto',
    border: '1px solid black',
    backgroundColor:'white',
    marginTop:'-19px',
    cursor:'pointer',
    padding:'4px',
    zIndex:'999',
    '& div': {
      borderBottom:'1px solid black'
    }
  }
});

const getResults = (
  name,
  backendRoutes
) => {
  const { CoderAutocomplete } = backendRoutes;

  const params = { name };

  const queryString = qs.stringify(params);

  const url = `${CoderAutocomplete}?${queryString}`;

  return fetch(url, {
    credentials: 'include'
  })
  .then(getResponseJson)
  .catch(e => {
    console.error(e.toString());
  });
};

const ACTION_TYPES = {
  CHANGE_INPUT_VALUE: 'CHANGE_INPUT_VALUE'
};

const ACTIONS = {
  changeInputValue: inputValue => ({
    type: ACTION_TYPES.CHANGE_INPUT_VALUE,
    payload: {
      inputValue
    }
  })
};

const autocompleteInitialState = {
  inputValue: ''
};

const autocompleteReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.CHANGE_INPUT_VALUE: {
      const { payload: { inputValue } } = action;
      return {
        ...state,
        inputValue
      };
    }

    default: {
      throw Error('autocompleteReducer should never hit default case');
    }
  }
};

const CoderAutocomplete = ({
  dateOfService,
  selectedEncoding,
  setSelectedEncoding,
  classes,
  handleDelete = () => {}
}) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fooState, fooDispatch] = useReducer(
    autocompleteReducer,
    autocompleteInitialState
  );
  const backendRoutes = useContext(RouteFetcherContext);

  const handleInputChange = e => {
    const value = e.target.value;

    if (!value || value.length < 3) {
      setOptions([]);
      return;
    }

    setIsLoading(true);

    getResults(
      value,
      backendRoutes
    )
    .then(responseJson => {
      const { result } = responseJson;
      setOptions(result);
      setIsLoading(false);
    })
    .catch(e => {
      console.error(e.toString());
      setIsLoading(false);
    });
  };

  const betterOnInputValueChange = v => {
    const nextVal = (v === undefined || v === null) ? '' : v;
    fooDispatch(ACTIONS.changeInputValue(nextVal));
  };

  return (
    <Downshift
      inputValue={fooState.inputValue}
      onInputValueChange={betterOnInputValueChange}
      selectedItem={selectedEncoding}
      onChange={setSelectedEncoding}
      itemToString={item => (item ? item.code : '')}
      onOuterClick={() => fooDispatch(ACTIONS.changeInputValue(''))}
    >
      {({
        getInputProps,
        getLabelProps,
        isOpen,
        getItemProps,
        highlightedIndex,
        selectedItem
      }) => {
        return (
          <div className={classes.root}>
            <div className={classes.primaryContainer}>

              {/* input section */}
              <div className={classes.inputContainer}>
                <label {...getLabelProps()}>Coder:</label>
                <input
                  {...getInputProps({
                    placeholder: 'Search Coders',
                    onChange: handleInputChange
                  })}
                />
                {
                  isLoading
                    ? (<CircularProgress variant="indeterminate" size="20px" />)
                    : null
                }
              </div>

              {/* selected item section */}
              <div className={classes.selectedItemContainer}>
                <span>
                  Audited Coders: {
                    selectedEncoding.length > 0 ?
                      selectedEncoding.map(x => (
                        <CoderChip
                          key={x.coderId}
                          isDelible={true}
                          onDelete={() => handleDelete(x.coderId, x)}
                          coder={x}
                        />)) :
                      'NONE'
                  }
                </span>
              </div>
            </div>

            {/* items list section */}
            {
              isOpen && options.length === 1 && options[0].name === null ? (
                <div className={classes.optionsContainer}>
                  <div
                    {...getItemProps({
                        key: null,
                        item: null,
                        index: 0,
                        style: {
                        backgroundColor: 'lightgray',
                        fontWeight: 'bold'
                      }
                    })}
                  >
                    NO MATCHES FOUND
                  </div>
                </div>
              ) : isOpen && options.length > 0 ? (
                <div className={classes.optionsContainer}>
                  {
                    options.map((o, i) => (
                      <div
                        {...getItemProps({
                          key: o.coderId,
                          item: o,
                          index: i,
                          style: {
                            backgroundColor: highlightedIndex === i ?
                              'lightgray' :
                              'white',
                            fontWeight: selectedItem &&
                              selectedItem.coderId === o.coderId ?
                                'bold' :
                                'normal'
                          }
                        })}
                      >
                        {o.name}
                      </div>
                    ))
                  }
                </div>
              ) : null
            }
          </div>
        );
      }}
    </Downshift>
  );
};

CoderAutocomplete.propTypes = {
  handleDelete: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(CoderAutocomplete);
